export default "__VITE_ASSET__BAhd7vUZ__";